import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { isEmpty, startCase } from 'lodash'
import InfiniteScroll from 'react-infinite-scroller';

import { fetchFcaTradeDocuments, resetFcaTradeDocuments } from '../actions';
import Loading from '../components/ListLoader';

import TradeDocument from '../components/TradeDocument';
import EmptyState from '../components/TradeDocumentEmptyState';

export class TradeDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      currentPage: 1,
      documentType: props.documentType,
      documentStatus: props.documentStatus,
    }
  }

  componentWillMount(){
    this.requestData(this.state.currentPage);
  }

  componentWillUnmount(){
    this.props.resetTradeDocuments()
  }

  requestData = (page) => {
    if (page > this.props.totalNoPages) return
    this.props.fetchTradeDocuments(() => this.setState({ loading: false, currentPage: page }), true, page)
  }

  onClickCard = (id, status, type) => {
    this.props.trackClickEvent();
    const docType = type === 'Invoice' ? 'invoices' : 'purchase_orders';
    this.props.redirectTo(status, docType, id, {status: this.state.documentStatus, docType: this.state.documentType })
  };

  componentWillReceiveProps(nextProps) {
    let newState = {}

    if(nextProps.documentType !== this.props.documentType) {
      newState.documentType =  nextProps.documentType
    }

    if(nextProps.documentStatus !== this.props.documentStatus) {
      newState.documentStatus = nextProps.documentStatus
    }

    this.setState(newState);
  }

  compareDocStatus = (document, documentStatus) => {
    if (documentStatus === "action_required") { return document.action_required }
    return !document.action_required && document.stage === documentStatus;
  }

  get filteredDocuments() {
    const { documentType, documentStatus }  = this.state;
    const { tradeDocuments } = this.props;

    if ((documentType === "") && (documentStatus === "")) return tradeDocuments;

    return tradeDocuments.filter((document) => {
      if (documentType !== "" && documentStatus !== "") {
        return document.trade_doc_type === documentType && this.compareDocStatus(document, documentStatus);
      } else if (documentType !== ""){
        return document.trade_doc_type === documentType
      } else {
        return this.compareDocStatus(document, documentStatus)
      }
    })
  }

  noDocsMessage = () => {
    let message = "No Results"

    if (this.state.documentType !== "" && this.state.documentStatus !== "") {
      message += ` for that combination of ${ startCase(this.state.documentType)} and ${ startCase(this.state.documentStatus) }`
    }
    else if (this.state.documentType !== "") {
      message += ` for ${ startCase(this.state.documentType) }`
    }
    else if (this.state.documentStatus !== "") {
      message += ` for ${ startCase(this.state.documentStatus) }`
    }

    return message
  }


  renderTradeDocuments = (filteredDocs) => {
    if (isEmpty(filteredDocs)) return <EmptyState message={this.noDocsMessage()}/>

    return (
      <Fragment>
        {
          filteredDocs.map((td) => {
            return (
              <TradeDocument
                key={td.document.id}
                index={td.index}
                onClick={() => this.onClickCard(td.document.id, td.document.status, td.document.trade_doc_type)}
                {...td.document}
              />
            )
          })
        }
      </Fragment>
    )
  }

  render() {
    if (this.state.loading) return <Loading />;

    let invoiceCurrentIndex = this.props.invoiceCount;
    let poCurrentIndex = this.props.purchaseOrderCount;

    let filteredDocs = this.filteredDocuments.map(doc => {
      return {
        document: doc,
        index: doc.trade_doc_type === 'Invoice' ? invoiceCurrentIndex-- : poCurrentIndex--
      }
    });

    return (
        <InfiniteScroll
          pageStart={1}
          hasMore={this.state.currentPage < this.props.totalNoPages}
          loadMore={this.requestData}
          loader={<Loading/>}
        >
          { this.renderTradeDocuments(filteredDocs) }
        </InfiniteScroll>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    tradeDocuments: state.applications.present.applications,
    index: state.applications.index,
    totalNoPages: state.applications.present.totalPages,
    invoiceCount: state.applications.present.invoiceCount,
    purchaseOrderCount: state.applications.present.purchaseOrderCount,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTradeDocuments: (callback, withDraft, page) => dispatch(fetchFcaTradeDocuments(callback, withDraft, page)),
    redirectTo: (status, docType, id, routeState) => {
      const url = status === 'draft' ? `/${docType}/${id}/new` : `/${docType}/${id}`;
      dispatch(push(url, routeState));
    },
    resetTradeDocuments: () => dispatch(resetFcaTradeDocuments()),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TradeDocuments);



// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/TradeDocuments.js